import { EventEmitter } from 'events';

import dispatcher from '../others/Dispatcher';

class NavbarStore extends EventEmitter {
    constructor() {
        super()
        this.authentication = true;
        this.username = '';
        this.user = 'MindTouch';
        this.repo = 'Deki';
        this.version = '2.0.4';
        this.anchor = 'left';
        this.open = false;

    }

    getAll() {
        const { authentication, username, user, repo, version, anchor, open } = this;
        return {
            authentication,
            username,
            user,
            repo,
            version,
            anchor,
            open,
        }
    }

    updateAuthentication(authentication) {
        this.authentication = authentication;
        this.emit('change');
    }

    updateUsername(username) {
        this.username = username;
        this.emit('change');
    }

    updateOpen(open) {
        this.open = open;
        this.emit('change');
    }

    handleActions(action) {
        switch(action.type) {
            case 'UPDATE_NAVBAR_AUTHENTICATION':
                this.updateAuthentication(action.body);
                break;
            case 'UPDATE_NAVBAR_USERNAME':
                this.updateUsername(action.body);
                break;
            case 'UPDATE_NAVBAR_OPEN':
                this.updateOpen(action.body);
                break;
            case 'UPDATE_AUTHENTICATION':
                this.updateAuthentication(action.body);
                break;
            default:
        }
    }

}

const navbarStore = new NavbarStore();
dispatcher.register(navbarStore.handleActions.bind(navbarStore));
window.navbarStore = navbarStore;
export default navbarStore;


// WEBPACK FOOTER //
// ./src/js/stores/NavbarStore.js